var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.$t("lang.label_certificate_history")))]),_c('b-table',{attrs:{"responsive":"sm","items":_vm.audits,"fields":_vm.fields}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }